import theme from 'theme'

const FormRow: React.FC = (props) => (
  <div
    css={{
      '& + &': {
        marginTop: theme.space[4]
      }
    }}
    {...props}
  />
)

export default FormRow
